import { Col } from "../Tools/Grid-system";
import { useContextHook } from "./ContextOPen";

function Translate() {
  const { content, changeLanguage, changeLanguage2 } = useContextHook();
  return (
    <div className="max-sm:pb-2">
      <Col sm={5} className="">
        <div>
          {localStorage.getItem("language") === "en" ? (
            <div
              onClick={changeLanguage}
              className="border w-fit px-3 cursor-pointer mt-1 h-10 border-Main flex justify-center hoverMain items-center after:bg-Main rounded-full transition-all relative overflow-hidden "
            >
              <p className="z-10 cursor-pointer">{content.English}</p>
            </div>
          ) : (
            <div
              onClick={changeLanguage2}
              className="border w-fit px-3 cursor-pointer mt-1 h-10 border-Main flex justify-center hoverMain items-center after:bg-Main rounded-full transition-all relative overflow-hidden "
            >
              <p className="z-10 cursor-pointer">{content.Arabic}</p>
            </div>
          )}
        </div>
      </Col>
    </div>
  );
}
export default Translate;
